var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFcPersonalLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 4H1C0.4 4 0 4.4 0 5V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V5C16 4.4 15.6 4 15 4ZM11.1 14H4.9C4.5 12.6 3.4 11.5 2 11.1V8.9C3.4 8.5 4.5 7.4 4.9 6H11.2C11.6 7.4 12.7 8.5 14.1 8.9V11.2C12.6 11.5 11.5 12.6 11.1 14Z",
    fill: "var(--fill-0, #86B4F9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 12C9.10457 12 10 11.1046 10 10C10 8.89543 9.10457 8 8 8C6.89543 8 6 8.89543 6 10C6 11.1046 6.89543 12 8 12Z",
    fill: "var(--fill-0, #86B4F9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14 0H2V2H14V0Z",
    fill: "var(--fill-0, #86B4F9)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcPersonalLoan);
export default __webpack_public_path__ + "static/media/fc-personal-loan.148d03e9c1412659c1f0c954c0cca040.svg";
export { ForwardRef as ReactComponent };